import { fieldTraitOptions } from '../dataGroup/traitsApi';
import { FieldTypes, FileUrlFields, textNumberField } from 'drapcode-constant';

export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId, collections } = opts;
  const defaultType = dc.getType("default");
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          "custom-name": label,
          projectId,
          droppable: false,
          icon: '<i class="fa fa-sticky-note"></i>',
          traits: [...defaultModel.prototype.defaults.traits],
             script: function () {
            if (typeof loadNotesData !== 'undefined') {
              loadNotesData(this);
            }
          },
        },
         syncTraitToAttribute(traitName) {
          const value = this.get(traitName);
          const currentAttributes = this.get('attributes') || {};
          this.set('attributes', {
            ...currentAttributes,
            [traitName]: value,
          });
           this.addAttributes({
    [traitName]: value
  });
        },

         init() {
          const collectionOptions = [
            { value: '', label: '- Select One -' },
            ...collections.map((col) => ({
              value: col.collectionName,
              label: col.collectionTitle,
            })),
          ];

          this.addTrait({
            type: 'select',
            label: 'Collection',
            name: 'data-notes-collection',
            options: collectionOptions,
            changeProp: 1,
          });

          this.on('change:data-notes-collection', async (model, newValue) => {
            console.log('Collection changed to:', newValue);
            this.syncTraitToAttribute('data-notes-collection')

            const traits = this.get('traits').filter(
              (t) => !['data-collection-field', 'save-data-to', 'get-notes-title', 'user-id'].includes(t.name)
            );
            this.set('traits', traits);
            const traitNamesToTrack =['data-collection-field', 'save-data-to', 'get-notes-title', 'user-id']
             traitNamesToTrack.forEach((trait) => {
            this.listenTo(this, `change:${trait}`, () => this.syncTraitToAttribute(trait));
          });

            if (newValue) {
              const collectionResponse = collections.find(
                (c) => c.collectionName === newValue
              );

              console.log("🚀 ~ collectionResponse:", collectionResponse);
              if (collectionResponse) {
                console.log("fieldTypes " ,FieldTypes);
                const collectionFields = collectionResponse.fields.map((item)=>{
                  return {
                    label:item.fieldTitle.en,
                    value:item.fieldName
                  }
                })
                const filterTraitOptions =  fieldTraitOptions(collectionResponse,[FieldTypes.text.id , FieldTypes.large_text.id]);
                console.log("🚀 ~ filterTraitOptions:", filterTraitOptions);

                if (filterTraitOptions && filterTraitOptions.length) {
                  this.addTrait({
                    label: 'Save Data To',
                    name: 'save-data-to',
                    type: 'select',
                    options: filterTraitOptions,
                    changeProp: 1,
                  });

                  this.addTrait({
                    label: 'Notes Title',
                    name: 'get-notes-title',
                    type: 'select',
                    options: filterTraitOptions,
                    changeProp: 1,
                  });

                  this.addTrait({
                    label: 'User ID',
                    name: 'user-id',
                    type: 'select',
                    options: collectionFields,
                    changeProp: 1,
                  });
                   this.syncTraitToAttribute('save-data-to');
          this.syncTraitToAttribute('get-notes-title');
          this.syncTraitToAttribute('user-id');
                }
              }
            }
          });
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute("data-gjs-type") === type) {
            return { type };
          }
        },
      }
    ),
    view: defaultView.extend({
      init({ model }) {
      },
    }),
  });
};




